import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { ErrorBoundary } from './ErrorBoundary';
import { setupSsoStub } from './ghl/sso';

// --- Verbose diagnostics (visible in the GHL iframe's DevTools console) ---
// Everything is tagged [pdc] so it's easy to filter. This is what a rep can
// screenshot when the panel misbehaves.
const t0 = performance.now();
console.info('[pdc] boot', {
  href: window.location.href,
  inIframe: window.top !== window.self,
  ua: navigator.userAgent,
  online: navigator.onLine,
  ts: new Date().toISOString(),
});

window.addEventListener('error', (e) =>
  console.error('[pdc] window.error:', e.message, e.filename, e.lineno, e.error),
);
window.addEventListener('unhandledrejection', (e) =>
  console.error('[pdc] unhandledrejection:', (e as PromiseRejectionEvent).reason),
);
window.addEventListener('online', () => console.info('[pdc] network online'));
window.addEventListener('offline', () => console.warn('[pdc] network OFFLINE'));

setupSsoStub();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);

console.info('[pdc] initial render dispatched in', Math.round(performance.now() - t0), 'ms');
